import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const PRINT_VIEW_ROUTE_PATH = `/print-view/:pid(${pidRegexStr as PID})/` as const

type PrintViewParams = PathParamMap<typeof PRINT_VIEW_ROUTE_PATH>

export const usePrintViewParams = (): PrintViewParams => useParams<PrintViewParams>()
